import { RefCallBack, useForm } from "react-hook-form";
import { Input } from "../../components/forms/Input";
import { useEffect, useState } from "react";
import { IBBApi } from "../../interfaces/IBB";
import BBTshirts from "./BBTshirt";
import BBActivities from "./BBActivities";

import HelperClass from "../../classes/HelperClass";
import RequestClass from "../../classes/RequestClass";

export interface IBBRegister {
    success_callback: RefCallBack | null; // return kiedy doadamy uczersnika
    bbApi?: IBBApi;
}

const BBRegister = (props: IBBRegister) => {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const [bbBasketValue, setbbBasketValue] = useState(0);
    const [activityId, setActivityId] = useState(0); // jako productId!
    const [tshirtId, setShirtId] = useState(0); // jako productId!
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [notification, setNotification] = useState<JSX.Element | String>();

    /* ----------------------------------------------------- */
    /* wysłanie formularza */
    function onSubmit(data: any) {
        if (activityId == 0) {
            setNotification(
                <div>
                    <span className=" tag is-danger">Wybierz pakiet startowy</span>
                </div>
            );
            return;
        }
        const err_callback = (result: any) => {
            if (setNotification) setNotification(RequestClass.errorAlert(result));
            setIsSubmitted(false);
        };

        const succ_callback = (result: any) => {
            //if (setNotification) setNotification(RequestClass.succAlert("Dziękujemy!", <div>Wiadomość zostało wysłana.</div>));
            // if (props.setIsSent) props.setIsSent(true);
            if (props.success_callback != undefined) props.success_callback(undefined);
            setIsSubmitted(false);
        };

        //console.log(data);
        let products = [];
        if (activityId > 0) {
            products.push({ productId: activityId, cnt: 1 });
        }
        if (tshirtId > 0) {
            products.push({ productId: tshirtId, cnt: 1 });
        }
        let dataToSend = {
            participant: {
                name: data.name,
                rankConsent: data.rankConsent,
                shortDesc: data.shortDesc,
            },
            products: products,
        };

        // console.log(dataToSend);

        var requestOptions = {
            method: "PUT",
            body: JSON.stringify(dataToSend),
        };
        RequestClass.makeRequest("bb/participant", requestOptions, succ_callback, err_callback);
        setIsSubmitted(true);
    }

    /* ----------------------------------------------------- */
    useEffect(() => {
        /* obliczanie sumy zamówienia */
        let suma = 0;
        let pInStore = HelperClass.getProductInProduct(tshirtId, props.bbApi?.products);
        if (pInStore?.price !== undefined) suma += pInStore.price;
        pInStore = HelperClass.getProductInProduct(activityId, props.bbApi?.products);
        if (pInStore?.price !== undefined) suma += pInStore.price;

        setbbBasketValue(suma);
        setNotification(<></>);
    }, [tshirtId, activityId]);

    /* ----------------------------------------------------- */
    return (
        <>
            <div className="pb-2 is-size-4">Rejestracja uczestnika</div>
            <div className="pb-2 is-size-7">Pola oznaczone * gwiazdką są obowiązkowe</div>

            <form>
                {/* <div className="mb-3 is-size-5">{props.title ? props.title : "Formularz kontaktowy:"}</div> */}
                {/* <p>
                    <Input
                        id={"imie"}
                        name="aName"
                        label="email *"
                        placeholder="email"
                        register={register}
                        // onChange={handleChange}
                        // defaultValue={props.data.aName}
                        // errors={props.errors}
                        // required={forceRequired}
                    ></Input>
                </p> */}
                <p className="pt-1">
                    <Input
                        id={"name"}
                        name="name"
                        label="* nazwa uczestnika: imię, nazwisko lub pseudonim"
                        placeholder="nazwa uczestnika"
                        register={register}
                        // onChange={handleChange}
                        // defaultValue={props.data.aName}
                        errors={errors}
                        // required={forceRequired}
                    ></Input>
                </p>
                <p className="pt-1">
                    <Input
                        id={"bbConsent"}
                        label="*Zapoznałem się i akceptuję regulaminem Biegu Belfrów"
                        register={register}
                        type="checkbox"
                        errors={errors}
                        defaultChecked={false}
                    ></Input>
                </p>
                <p className="pt-3">
                    <Input
                        id={"shortDesc"}
                        name="shortDesc"
                        label="napisz skąd jesteś, na przykład SP999 GdAńsk, możesz użyć 24 znaków"
                        placeholder="skąd jesteś"
                        register={register}
                        // onChange={handleChange}
                        // defaultValue={props.data.aName}
                        errors={errors}
                        required={false}
                    ></Input>
                </p>
                <div className="py-3 is-size-5">*Wybierz pakiet startowy:</div>
                <div className="container">
                    <BBActivities activityId={activityId} setActivityId={setActivityId} products={props.bbApi?.products} />
                </div>
                <div className="py-3 is-size-5">Wybierz koszulkę:</div>
                <BBTshirts tshirtId={tshirtId} setShirtId={setShirtId} products={props.bbApi?.products} />
                <hr></hr>
                <div>Nowość !</div>
                <div>Weź udział w dodatkowej rywalizacji w ramach wybranego pakietu.</div>
                <Input
                    id={"rankConsent"}
                    label=<span>
                        Oświadczam, że jestem Belfrem i chcę wziąć udział w dodatkowej rywalizacji <strong>Indywidualny Ranking Belfrów</strong>
                    </span>
                    register={register}
                    required={false}
                    type="checkbox"
                ></Input>
                <div className="is-size-6">
                    <a href="">Zasady Indywidualnego Rankingu Belfrów</a>
                </div>
                <hr></hr>
                <div className="py-3">
                    Suma do zapłaty: <span className="is-size-4">{bbBasketValue} zł</span>
                </div>

                <button className={` mt-2 button is-primary ` + (isSubmitted ? "is-loading" : "")} type="submit" onClick={handleSubmit(onSubmit)}>
                    Zarejestruj uczestnika na 5 Bieg Belfrów
                </button>
                {notification}
            </form>
        </>
    );
};

export default BBRegister;
